export default __webpack_public_path__ + "static/media/BIODY-XPERT-3-.7a4641e8.png";